
    <!--
 * 竖版-登陆信息
 * @LastEditTime: Sat Feb 08 2025 17:56:13 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_PO3569"  :class="[`normal`,`u_c_PO3569`]" ><div id="u_c_X02L21"  :style="`background-color:${ pageData.btnColor }`" :class="[`normal`,`u_c_X02L21`]" ></div><div id="u_c_TUYQ70"  v-show="pageData.isFacebookCollect ? pageData.facebookServerId && pageData.facebookRoleId : compData.isBind || pageData.serverId && pageData.roleId && pageData.serverId !== '0' && pageData.roleId !== '0'" :class="[`normal`,`u_c_TUYQ70`]" @click="u_c_TUYQ70_event_1X0X17($event)"><div id="u_c_2SI371"  :class="[`normal item btn-text`,`u_c_2SI371`]" ><div id="u_c_RB9272"  :class="[`normal text`,`u_c_RB9272`]" >{{`${ langData.serverTitle }：`}}</div><div id="u_c_50NI74"  :class="[`normal text`,`u_c_50NI74`]" >{{`${ pageData.serverName }`}}</div></div><div id="u_c_LSMF76"  :class="[`normal item btn-text`,`u_c_LSMF76`]" ><div id="u_c_SUB977"  :class="[`normal text`,`u_c_SUB977`]" >{{`${ langData.roleTitle }：`}}</div><div id="u_c_6C8J79"  :class="[`normal text`,`u_c_6C8J79`]" >{{`${ pageData.roleName }`}}</div></div><a id="u_c_GIAM22" href="javascript:;" v-show="pageData.isLogin" :class="[`normal btn-text`,`u_c_GIAM22`]" @click="u_c_GIAM22_event_H02I17($event)">{{`${ langData.logout }`}}</a></div><div id="u_c_5YPS81"  v-show="!(pageData.isFacebookCollect ? pageData.facebookServerId && pageData.facebookRoleId : compData.isBind || pageData.serverId && pageData.roleId && pageData.serverId !== '0' && pageData.roleId !== '0')" :class="[`normal`,`u_c_5YPS81`]" ><div id="u_c_55UT82"  :class="[`normal`,`u_c_55UT82`]" ><a id="u_c_052C84" href="javascript:;" :class="[`normal btn-text`,`u_c_052C84`]" @click="u_c_052C84_event_H02I17($event)">{{`${ pageData.isLogin ? langData.gotoBind : langData.pleaseLogin }`}}</a><a id="u_c_YME319" href="javascript:;" v-show="pageData.isLogin" :class="[`normal btn-text`,`u_c_YME319`]" @click="u_c_YME319_event_H02I17($event)">{{`${ langData.logout }`}}</a></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"isBind":true},"zh-TW":{"isBind":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "gm99"
    const router = Router();
    const route = useRoute();
    const compName = '登陆信息';

    // 自定义setup - 开始
     const clickCheckIsLogin = inject("clickCheckIsLogin", () => {});

compData.isBind = false;
      // 已绑定box的click事件
      const u_c_TUYQ70_event_1X0X17= async (e)=>{
        try { if (clickCheckIsLogin()) {
   if (pageData.isFacebookCollect && pageData.facebookRoleId && pageData.facebookServerId) return;
   pageData.bindPopupState = true;
 }

 try {
   window.dataLayer.push({
     event: "uploadPoint",
     eventName: "点击展开绑定弹窗",
     aid: pageData.pageId
   });
 } catch (error) {}} catch (error) {console.log(error)}
      };
      // 点击登出账号的click事件
      const u_c_GIAM22_event_H02I17= async (e)=>{
        try { if (clickCheckIsLogin()) {
   e.stopPropagation()
   let link = {
     gm99: `https://passport.gm99.com/login/logout2`,
     global: `https://gpassport.${utils.getMainHost()}/web_login/logout`,
   }
   const curPlatform = utils.getMainHost() == "gm99.com" ? "gm99" : "global";
   let res = await request.getJSON(link[curPlatform])
   if (res.result == 1) {
     window.location.reload()
   }
 }} catch (error) {console.log(error)}
      };
      // 点击绑定的click事件
      const u_c_052C84_event_H02I17= async (e)=>{
        try { if (clickCheckIsLogin()) {
          pageData.bindPopupState = true;
        }
try {
            window.dataLayer.push({
              event: "uploadPoint",
              eventName: "点击展开绑定弹窗",
              aid:pageData.pageId
            });
          } catch (error) {}} catch (error) {console.log(error)}
      };
      // 点击登出账号的click事件
      const u_c_YME319_event_H02I17= async (e)=>{
        try { if (clickCheckIsLogin()) {
   e.stopPropagation()
   let link = {
     gm99: `https://passport.gm99.com/login/logout2`,
     global: `https://gpassport.${utils.getMainHost()}/web_login/logout`,
   }
   const curPlatform = utils.getMainHost() == "gm99.com" ? "gm99" : "global";
   let res = await request.getJSON(link[curPlatform])
   if (res.result == 1) {
     window.location.reload()
   }
 }} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_PO3569.normal{
position:relative;
width:9.47rem;
height:0.85rem;
display:block;
top:6.83rem;
color:#80524C;
font-size:0.35rem;
z-index:2;
margin:auto;

}
}.default{
.u_c_X02L21.normal{
position:absolute;
background-color:#F8F0DB;
border-radius:0.21rem;
opacity:0.8;
width:100%;
height:100%;

}
}.default{
.u_c_TUYQ70.normal{
position:relative;
justify-content:center;
align-items:center;
height:100%;
width:100%;
display:flex;
cursor:pointer;

}

.u_c_TUYQ70.normal .item{
margin:auto 0.27rem;

}

.u_c_TUYQ70.normal:hover{
cursor:pointer;

}
}.default{
.u_c_2SI371.normal{
position:relative;
display:flex;
align-items:center;
justify-content:center;

}
}.default{
.u_c_RB9272.normal{
position:relative;

}
}.default{
.u_c_50NI74.normal{
position:relative;

}
}.default{
.u_c_LSMF76.normal{
position:relative;
display:flex;
align-items:center;
justify-content:center;

}
}.default{
.u_c_SUB977.normal{
position:relative;

}
}.default{
.u_c_6C8J79.normal{
position:relative;

}
}.default{
.u_c_GIAM22.normal{
position:absolute;
text-decoration:underline;
margin:auto 0.20rem;
color:#FFF;
bottom:-0.67rem;

}
}.default{
.u_c_5YPS81.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
height:100%;
box-sizing:border-box;
padding:0 0.40rem;

}
}.default{
.u_c_55UT82.normal{
position:relative;
text-align:center;
line-height:120%;

}
}.default{
.u_c_052C84.normal{
position:relative;
text-decoration:underline;
margin:auto 0.20rem;
color:#1A6EEE;

}
}.default{
.u_c_YME319.normal{
position:relative;
text-decoration:underline;
margin:auto 0.20rem;
color:#FFF;

}
}.zh-TW{
.u_c_PO3569.normal{
position:relative;
width:9.47rem;
height:0.85rem;
display:block;
top:6.83rem;
color:#80524C;
font-size:0.35rem;
z-index:2;
margin:auto;

}
}.zh-TW{
.u_c_X02L21.normal{
position:absolute;
background-color:#F8F0DB;
border-radius:0.21rem;
opacity:0.8;
width:100%;
height:100%;

}
}.zh-TW{
.u_c_TUYQ70.normal{
position:relative;
justify-content:center;
align-items:center;
height:100%;
width:100%;
display:flex;
cursor:pointer;

}

.u_c_TUYQ70.normal .item{
margin:auto 0.27rem;

}

.u_c_TUYQ70.normal:hover{
cursor:pointer;

}
}.zh-TW{
.u_c_2SI371.normal{
position:relative;
display:flex;
align-items:center;
justify-content:center;

}
}.zh-TW{
.u_c_RB9272.normal{
position:relative;

}
}.zh-TW{
.u_c_50NI74.normal{
position:relative;

}
}.zh-TW{
.u_c_LSMF76.normal{
position:relative;
display:flex;
align-items:center;
justify-content:center;

}
}.zh-TW{
.u_c_SUB977.normal{
position:relative;

}
}.zh-TW{
.u_c_6C8J79.normal{
position:relative;

}
}.zh-TW{
.u_c_GIAM22.normal{
position:absolute;
text-decoration:underline;
margin:auto 0.20rem;
color:#FFF;
bottom:-0.67rem;

}
}.zh-TW{
.u_c_5YPS81.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
height:100%;
box-sizing:border-box;
padding:0 0.40rem;

}
}.zh-TW{
.u_c_55UT82.normal{
position:relative;
text-align:center;
line-height:120%;

}
}.zh-TW{
.u_c_052C84.normal{
position:relative;
text-decoration:underline;
margin:auto 0.20rem;
color:#1A6EEE;

}
}.zh-TW{
.u_c_YME319.normal{
position:relative;
text-decoration:underline;
margin:auto 0.20rem;
color:#FFF;

}
}
</style>
